module.exports = __webpack_public_path__ + "static/media/20210410_153410_233_IMG_0234.3933b3a8.jpg";